"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import CarrierTypeAhead from "../carrier_typeahead";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
function carrierFromProps(props) {
  return props.carrier.id ? props.carrier : null;
}
function stateFromProps(props) {
  return {
    carrier_id: props.carrier ? props.carrier.id : void 0,
    carrier: carrierFromProps(props),
    userSelectedCarrier: false
  };
}
export default React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return __spreadProps(__spreadValues({}, stateFromProps(this.props)), { advancedSearch: false });
  },
  componentDidMount: function() {
    var self = this;
    if (this.props.carrier.promise) {
      this.props.carrier.promise.then(function(result) {
        self.setState({ carrier: result.carrier });
      });
    }
  },
  componentWillReceiveProps: function(newProps) {
    if (!this.state.userSelectedCarrier) {
      this.setState(stateFromProps(newProps));
    }
  },
  // STATE
  //
  selectCarrier: function(carrier) {
    this.setState({
      carrier_id: carrier ? carrier.id : void 0,
      carrier,
      userSelectedCarrier: true
    });
  },
  search: function(e) {
    if (e) e.preventDefault();
    this.props.onSearch(this.terms());
  },
  terms: function() {
    return _.object(
      _.reject(_.pairs(this.state), function(pair) {
        return _.first(pair) === "carrier";
      })
    );
  },
  toggleAdvancedFields: function() {
    this.setState({ advancedSearch: !this.state.advancedSearch });
  },
  // RENDERING
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "import-detail__search " }, /* @__PURE__ */ React.createElement("form", { onSubmit: this.search }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "id-or-reference" }, "ID or Reference"), /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        id: "id-or-reference",
        type: "text",
        autoFocus: true,
        valueLink: this.linkState("reference"),
        className: "mousetrap-allow-text"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, Account.carrierTerm()), /* @__PURE__ */ React.createElement(
      CarrierTypeAhead,
      {
        carrier: this.state.carrier,
        onSelectCarrier: this.selectCarrier,
        onClearCarrier: this.selectCarrier
      }
    ))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 columns load-search-form__advanced-search-toggle" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("a", { onClick: this.toggleAdvancedFields }, "Advanced search")))), this.advancedFields(), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, this.searchButton()))));
  },
  searchButton: function() {
    if (this.props.searching) {
      return /* @__PURE__ */ React.createElement("button", { disabled: true, className: "small" }, "Searching...");
    } else {
      return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "button--confirmation" }, "Search"), " ", /* @__PURE__ */ React.createElement("span", { className: "load-search-form__cancel-or" }, "or "), /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "load-search-form__cancel-link",
          onClick: this.props.onCancel
        },
        "cancel"
      ));
    }
  },
  advancedFields: function() {
    if (this.state.advancedSearch) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "Start Ship Date"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          value: this.state.ship_start || "",
          onChange: (e) => this.setState({
            ship_start: e.target.value
          })
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "End Ship Date"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          value: this.state.ship_end || "",
          onChange: (e) => this.setState({
            ship_end: e.target.value
          })
        }
      )));
    }
  }
});
